<template>
	<ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
	    <li :class="[currentPage.includes('home') ? activeClass : '', 'nav-item']">
	    	<router-link to="/home" exact><i class="feather icon-home"></i> <span class="menu-title">{{trans('general.home')}}</span>
	    	</router-link>
	    </li>

		<li :class="[currentPage.includes('tax-payer') ? activeClass : '', 'nav-item']" v-if="hasPermission('list-tax-payer')">
	    	<router-link to="/tax-payer" exact><i class="feather icon-users"></i> <span class="menu-title">Tax Payer</span>
	    	</router-link>
	    </li>

		<li class="nav-item has-sub" v-if="hasPermission('list-payment')">
            <a href="">
                <i class="feather icon-dollar-sign"></i>
                <span class="menu-title" data-i18n="">Bills & Payment</span>
            </a>
            <ul class="menu-content" style="">
            	<li :class="[this.$router.history.current.path == '/payment/create' ? activeClass : '', 'nav-item']" v-if="hasPermission('list-payment')">
	    			<router-link to="/payment/create" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Generate Bill
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[this.$router.history.current.path == '/payment' ? activeClass : '']">
	            	<router-link to="/payment" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Pay or Confirm Payment
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[this.$router.history.current.path == '/pos-transaction' ? activeClass : '', 'nav-item']" v-if="hasPermission('list-pos-transaction')">
	    			<router-link to="/pos-transaction" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					POS Transactions
	    				</span>
	    			</router-link>
	    		</li>
		    </ul>                                            
		</li>

		<li class="nav-item has-sub" v-if="getAuthUser('type') == 'business'">
            <a href="">
                <i class="feather icon-users"></i>
                <span class="menu-title" data-i18n="">Pay As You Earn</span>
            </a>
            <ul class="menu-content" style="">
            	<li :class="[this.$router.history.current.path == '/paye/staff' ? activeClass : '', 'nav-item']">
	    			<router-link to="/paye/staff" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Manage Staff
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[this.$router.history.current.path == '/user/paye-remitance' ? activeClass : '']">
	            	<router-link to="/paye/paye-remitance" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			PAYE Remitance
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[this.$router.history.current.path == '/user/paye-liability' ? activeClass : '']">
	            	<router-link to="/paye/paye-liability" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			PAYE Liability
	            		</span>
	            	</router-link>
	    		</li>
		    </ul>                                            
		</li>

		<li class="nav-item has-sub" v-if="hasPermission('list-receipt') && getConfig('show_receipt_menu')">
            <a href="">
                <i class="feather icon-printer"></i>
                <span class="menu-title" data-i18n="">Tax Receipt</span>
            </a>
            <ul class="menu-content" style="">
				<li :class="[this.$router.history.current.path == '/receipt' ? activeClass : '', 'nav-item']" v-if="hasPermission('list-receipt')">
	            	<router-link to="/receipt" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			View Receipt
	            		</span>
	            	</router-link>
	    		</li>
				
            	<li :class="[this.$router.history.current.path == '/receipt/create' ? activeClass : '', 'nav-item']" v-if="hasPermission('create-receipt')">
	    			<router-link to="/receipt/create" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Generate Receipt
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[this.$router.history.current.path == '/receipt/verify' ? activeClass : '', 'nav-item']" v-if="hasPermission('verify-receipt')">
	            	<router-link to="/receipt/verify" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			RePrint Receipt
	            		</span>
	            	</router-link>
	    		</li>

		    </ul>                                            
		</li>

		<li class="nav-item has-sub" v-if="hasPermission('list-e-filling') && getConfig('show_efilling_menu')">
            <a href="">
                <i class="feather icon-file-text"></i>
                <span class="menu-title" data-i18n="">Returns Filling</span>
            </a>
            <ul class="menu-content" style="">
            	<li :class="[currentPage.includes('e-filling') ? activeClass : '', 'nav-item']" v-if="hasPermission('list-e-filling')">
	    			<router-link to="/e-filling" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					E-Filing
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('annual-return') ? activeClass : '']" v-if="hasPermission('list-annual-return')">
	            	<router-link to="/annual-return" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Annual Report
	            		</span>
	            	</router-link>
	    		</li>
		    </ul>                                            
		</li>


		<li :class="[currentPage.includes('tcc') ? activeClass : '', 'nav-item']" v-if="hasPermission('list-tcc') && getConfig('show_tcc_menu')">
	    	<router-link to="/tcc" exact>
	    		<i class="feather icon-check"></i> 
	    		<span class="menu-title">
	    			TCC
	    		</span>
	    	</router-link>
	    </li>

		<li class="nav-item has-sub" v-if="hasPermission('list-demand-notice') && getConfig('show_demand_notice_menu')">
            <a href="">
                <i class="feather icon-bell"></i>
                <span class="menu-title" data-i18n="">Demand Notice</span>
            </a>
            <ul class="menu-content" style="">
				<li :class="[this.$router.history.current.path == '/demand-notice' ? activeClass : '', 'nav-item']" v-if="hasPermission('list-demand-notice')">
	            	<router-link to="/demand-notice" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			View Demand Notice
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[this.$router.history.current.path == '/demand-notice/generate' ? activeClass : '', 'nav-item']" v-if="hasPermission('create-demand-notice')">
	    			<router-link to="/demand-notice/generate" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Generate
	    				</span>
	    			</router-link>
	    		</li>
				
            	<li :class="[this.$router.history.current.path == '/demand-notice/create' ? activeClass : '', 'nav-item']" v-if="hasPermission('create-demand-notice')">
	    			<router-link to="/demand-notice/create?type=individual" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Generate For Individual
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[this.$router.history.current.path == '/demand-notice/group/create' ? activeClass : '', 'nav-item']" v-if="hasPermission('create-demand-notice')">
	            	<router-link to="/demand-notice/create?type=group" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Generate For Group
	            		</span>
	            	</router-link>
	    		</li>

		    </ul>                                            
		</li>

	    <li class="nav-item has-sub" v-if="hasPermission('list-e-filling') && getConfig('show_user_menu')">
            <a href="">
                <i class="feather icon-navigation"></i>
                <span class="menu-title" data-i18n="">Joint Tax Board</span>
            </a>
            <ul class="menu-content" style="">
            	<li :class="[currentPage.includes('individual-jtb') ? activeClass : '', 'nav-item']" v-if="hasPermission('list-e-filling')">
	    			<router-link to="/individual-jtb" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Individual
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('non-individual-jtb') ? activeClass : '']" v-if="hasPermission('list-annual-return')">
	            	<router-link to="/non-individual-jtb" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Non-Individual
	            		</span>
	            	</router-link>
	    		</li>
		    </ul>                                            
		</li>

		<li :class="[currentPage.includes('vehicle-registration') ? activeClass : '', 'nav-item']" v-if="hasPermission('list-vehicle-registration')">
	    	<router-link to="/vehicle-registration" exact><i class="fas fa-car"></i> <span class="menu-title">Vehicle Registration</span>
	    	</router-link>
	    </li>

		<li :class="[currentPage.includes('staff') ? activeClass : '', 'nav-item']" v-if="hasPermission('list-user') && getConfig('show_user_menu')">
			<router-link to="/staff" exact>
				<i class="feather icon-users"></i> 
				<span class="menu-title">
					Staff
				</span>
			</router-link>
		</li>

	    <li class="nav-item has-sub" v-if="hasPermission('access-settings')">
            <a href="">
                <i class="feather icon-settings"></i>
                <span class="menu-title" data-i18n="">Settings</span>
            </a>
            <ul class="menu-content" style="">
				<li :class="[currentPage.includes('setting/business-type') ? activeClass : '']">
	            	<router-link to="/setting/business-type" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Business Type
	            		</span>
	            	</router-link>
	    		</li>
            	<li :class="[currentPage.includes('category') ? activeClass : '']">
	    			<router-link to="/setting/category" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Category
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('setting/sub-category') ? activeClass : '']">
	            	<router-link to="/setting/sub-category" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Sub Category
	            		</span>
	            	</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('setting/tax-rate') ? activeClass : '']">
	            	<router-link to="/setting/tax-rate" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Tax Rate
	            		</span>
	            	</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('gateway') ? activeClass : '']">
	    			<router-link to="/setting/gateway" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Gateway
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('mda') ? activeClass : '']">
	    			<router-link to="/setting/mda" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					MDA
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('setting/pay-item') ? activeClass : '']">
	            	<router-link to="/setting/pay-item" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Pay Item
	            		</span>
	            	</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('setting/tax-office') ? activeClass : '']">
	            	<router-link to="/setting/tax-office" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Tax Office
	            		</span>
	            	</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('organization') ? activeClass : '']">
	    			<router-link to="/setting/organization" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Organization
	    				</span>
	    			</router-link>
	    		</li>

				<li :class="[currentPage.includes('occupation') ? activeClass : '']">
	    			<router-link to="/setting/occupation" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Occupation
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('sector') ? activeClass : '']">
	    			<router-link to="/setting/sector" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Sector
	    				</span>
	    			</router-link>
	    		</li>

				<li :class="[currentPage.includes('sector-line') ? activeClass : '']">
	    			<router-link to="/setting/sector-line" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Sector Line
	    				</span>
	    			</router-link>
	    		</li>

				<li :class="[currentPage.includes('demand-notice-pay-item') ? activeClass : '']">
	    			<router-link to="/setting/demand-notice-pay-item" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Demand Notice Pay Item
	    				</span>
	    			</router-link>
	    		</li>
		    </ul>                                            
		</li>

	    <li :class="[currentPage.includes('todo') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-todo') && getConfig('show_todo_menu')">
	    	<router-link to="/todo" exact>
	    		<i class="feather icon-check-circle"></i> 
	    		<span class="menu-title">
	    			{{trans('todo.todo')}}
	    		</span>
	    	</router-link>
	    </li>
	    <li :class="[currentPage.includes('message') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-message') && getConfig('show_message_menu')">
	    	<router-link to="/message" exact>
	    		<i class="feather icon-mail"></i> 
	    		<span class="menu-title">
	    			{{trans('message.message')}}
	    		</span>
	    	</router-link>
	    </li>

	    <li :class="[currentPage.includes('configuration') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-sms') && getConfig('show_sms_menu')">
	    	<router-link to="/configuration/sms" exact>
	    		<i class="feather icon-message-circle"></i> 
	    		<span class="menu-title">
	    			{{trans('general.sms')}}
	    		</span>
	    	</router-link>
	    </li>

	   <li class="nav-item has-sub" v-if="hasPermission('access-configuration') && getConfig('show_email_menu')">
	   		<a href="">
	   			<i class="feather icon-inbox"></i>
	   			<span class="menu-title" data-i18n="">
	   				Email
   				</span>
   			</a>
   			<ul class="menu-content" style="">
   				<li :class="[currentPage.includes('email-template') ? activeClass : '']" v-if="hasPermission('access-configuration') && getConfig('show_email_template_menu')">
    				<router-link to="/email-template" exact>
			    		<i class="feather icon-mail"></i> 
			    		<span class="menu-title">
			    			{{trans('template.email_template')}}
			    		</span>
			    	</router-link>
	    		</li>
			    <li :class="[currentPage.includes('email-log') ? activeClass : '']" v-if="hasPermission('access-configuration') && getConfig('show_email_log_menu')">
			    	<router-link to="/email-log" exact>
			    		<i class="feather icon-mail"></i> 
			    		<span class="menu-title">
			    			{{trans('mail.email_log')}}
			    		</span>
			    	</router-link>
			    </li>
   			</ul>
	   </li>

	   <li class="nav-item has-sub" v-if="hasPermission('access-configuration') && getConfig('show_settings_menu')">
            <a href="">
                <i class="feather icon-settings"></i>
                <span class="menu-title" data-i18n="">System Settings</span>
            </a>
            <ul class="menu-content" style="">
	        	<li :class="[currentPage.includes('basic') ? activeClass : '']">
	        		<router-link to="/configuration/basic" exact>
	        			<i class="feather icon-settings"></i> 
	        			<span class="menu-title">
	        				{{trans('configuration.basic_configuration')}}
	        			</span>
	        		</router-link> 
	            </li>

	            <li :class="[currentPage.includes('logo') ? activeClass : '']">
	            	<router-link to="/configuration/logo" exact>
	            		<i class="feather icon-image"></i> 
	            		<span class="menu-title">
	            			{{trans('general.logo')}}
	            		</span>
	            	</router-link>
	    		</li>
	    		<li :class="[currentPage.includes('system') ? activeClass : '']">
	    			<router-link to="/configuration/system" exact>
	    				<i class="feather icon-settings"></i> 
	    				<span class="menu-title">
	    					{{trans('configuration.system_configuration')}}
	    				</span>
	    			</router-link>
	    		</li>
	    		<li :class="[currentPage.includes('mail') ? activeClass : '']">
	    			<router-link to="/configuration/mail" exact>
	    				<i class="feather icon-mail"></i> 
	    				<span class="menu-title">
	    					{{trans('mail.mail_configuration')}}
	    				</span>
	    			</router-link>
	    		</li>
	    		<li :class="[currentPage.includes('locale') ? activeClass : '']" v-if="getConfig('multilingual')">
	    			<router-link to="/configuration/locale" exact>
	    				<i class="fas fa-globe"></i> 
	    				<span class="menu-title">
	    					{{trans('locale.locale')}}
	    				</span>
	    			</router-link>
	    		</li>
	    		<li :class="[currentPage.includes('menu') ? activeClass : '']">
	    			<router-link to="/configuration/menu" exact>
	    				<i class="feather icon-list"></i> 
	    				<span class="menu-title">
	    					{{trans('general.menu')}}
	    				</span>
	    			</router-link>
	    		</li>
	        	<li :class="[currentPage.includes('authentication') ? activeClass : '']">
	        		<router-link to="/configuration/authentication" exact>
	        			<i class="feather icon-log-in"></i> 
	        			<span class="menu-title">
	        				{{trans('auth.authentication')}}
	        			</span>
	        		</router-link>
	    		</li>
	            
		    </ul>                                            
		</li>

		<li class="nav-item has-sub" v-if="hasPermission('access-configuration') && getConfig('show_permission_menu')">
            <a href="">
                <i class="feather icon-lock"></i>
                <span class="menu-title" data-i18n="">Permissions</span>
            </a>
            <ul class="menu-content" style="">
	        	<li :class="[currentPage.includes('role') ? activeClass : '']">
	        		<router-link to="/configuration/role" exact>
	        			<i class="feather icon-log-in"></i> 
	        			<span class="menu-title">
	        				{{trans('role.role')}}
	        			</span>
	        		</router-link>
	        	</li>
	    		<li :class="[currentPage.includes('permission') ? activeClass : '']">
	    			<router-link to="/configuration/permission" exact>
	    				<i class="feather icon-lock"></i> 
	    				<span class="menu-title">
	    					{{trans('permission.permission')}}
	    				</span>
	    			</router-link>
	    		</li>
	            
		    </ul>                                            
		</li>
	    
	    <li :class="[currentPage.includes('activity-log') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-configuration') && getConfig('show_activity_log_menu')">
	    	<router-link to="/activity-log" exact>
	    		<i class="feather icon-activity"></i> 
	    		<span class="menu-title">
	    			{{trans('activity.activity_log')}}
	    		</span>
	    	</router-link>
	    </li>
	    <li :class="[currentPage.includes('ip-filter') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-configuration') && getConfig('ip_filter')">
	    	<router-link to="/configuration/ip-filter" exact>
	    		<i class="feather icon-filter"></i> 
	    		<span class="menu-title">
	    			{{trans('ip_filter.ip_filter')}}
	    		</span>
	    	</router-link>
	    </li>
	    <li :class="[currentPage.includes('scheduled-job') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-configuration') && getConfig('show_schedule_job_menu')">
	    	<router-link to="/configuration/scheduled-job" exact>
	    		<i class="feather icon-clock"></i> 
	    		<span class="menu-title">
	    			{{trans('general.scheduled_job')}}
	    		</span>
	    	</router-link>
	    </li>
	    <li :class="[currentPage.includes('backup') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-configuration') && getConfig('show_backup_menu')">
	    	<router-link to="/backup" exact>
	    		<i class="feather icon-box"></i> 
	    		<span class="menu-title">
	    			{{trans('backup.backup')}}
	    		</span>
	    	</router-link>
	    </li>

		<li :class="[currentPage.includes('clearance') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-clearance') && getConfig('show_user_menu')">
			<router-link to="/clearance" exact>
				<i class="feather icon-award"></i> 
				<span class="menu-title">
					Clearance
				</span>
			</router-link>
		</li>

		<li class="nav-item has-sub" v-if="hasPermission('list-marriage-certificate')">
            <a href="">
                <i class="feather icon-bell"></i>
                <span class="menu-title" data-i18n="">Marriage Certificate</span>
            </a>
            <ul class="menu-content" style="">
				<li :class="[this.$router.history.current.path == '/marriage-certificate' ? activeClass : '', 'nav-item']" v-if="hasPermission('list-marriage-certificate')">
	            	<router-link to="/marriage-certificate" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			View Certificates
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[this.$router.history.current.path == '/marriage-certificate/create' ? activeClass : '', 'nav-item']" v-if="hasPermission('create-marriage-certificate')">
	    			<router-link to="/marriage-certificate/create" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					Add Certificate
	    				</span>
	    			</router-link>
	    		</li>

		    </ul>                                            
		</li>
		

		<li :class="[currentPage.includes('report') ? activeClass : '', 'nav-item has-sub']" v-if="hasPermission('list-report')">
            <a href="">
                <i class="feather icon-navigation"></i>
                <span class="menu-title" data-i18n="">Collection Report</span>
            </a>
            <ul class="menu-content" style="">
				<li :class="[currentPage.includes('summary') ? activeClass : '']">
	            	<router-link to="/report/summary" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Summary
	            		</span>
	            	</router-link>
	    		</li>
				
            	<li :class="[currentPage.includes('by-mda') ? activeClass : '']">
	            	<router-link to="/report/by-mda" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Invoice/Receipt
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[currentPage.includes('demand-notice') ? activeClass : '']">
	            	<router-link to="/report/demand-notice" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			Demand Notice
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[currentPage.includes('by-mla-user') ? activeClass : '']">
	            	<router-link to="/report/by-mla-user" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			MLA
	            		</span>
	            	</router-link>
	    		</li>
		    </ul>                                            
		</li>

		<!-- <li :class="[currentPage.includes('report') ? activeClass : '', 'nav-item has-sub']" v-if="hasPermission('list-report')">
            <a href="">
                <i class="feather icon-navigation"></i>
                <span class="menu-title" data-i18n="">Collection Report</span>
            </a>
            <ul class="menu-content" style="">
            	<li :class="[currentPage.includes('by-staff') ? activeClass : '', 'nav-item']" v-if="hasPermission('list-report-by-staff')">
	    			<router-link to="/report/by-staff" exact>
	    				<i class="feather icon-list"></i>
	    				<span class="menu-title">
	    					By Staff
	    				</span>
	    			</router-link>
	    		</li>

	    		<li :class="[currentPage.includes('by-item') ? activeClass : '']" v-if="hasPermission('list-report-by-item')">
	            	<router-link to="/report/by-item" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			By Item
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[currentPage.includes('by-mda') ? activeClass : '']" v-if="hasPermission('list-report-by-mda')">
	            	<router-link to="/report/by-mda" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			By MDA
	            		</span>
	            	</router-link>
	    		</li>

				<li :class="[currentPage.includes('by-sector') ? activeClass : '']" v-if="hasPermission('list-report-by-sector')">
	            	<router-link to="/report-by-sector" exact>
	            		<i class="feather icon-list"></i>
	            		<span class="menu-title">
	            			By Sector
	            		</span>
	            	</router-link>
	    		</li>
		    </ul>                                            
		</li> -->

	    <li :class="[currentPage.includes('virtual-account') ? activeClass : '', 'nav-item']" v-if="userRole == 'admin'">
	    	<router-link to="/virtual-account" exact>
	    		<i class="feather icon-server"></i> 
	    		<span class="menu-title">
	    			Virtual Account
	    		</span>
	    	</router-link>
	    </li>

		<!-- <li :class="[currentPage.includes('sweeping') ? activeClass : '', 'nav-item']" v-if="userRole == 'admin'">
	    	<router-link to="/sweeping" exact>
	    		<i class="feather icon-dollar-sign"></i> 
	    		<span class="menu-title">
	    			Sweeping
	    		</span>
	    	</router-link>
	    </li>

		<li :class="[currentPage.includes('payout') ? activeClass : '', 'nav-item']" v-if="hasPermission('access-comission')">
	    	<router-link to="/payout" exact>
	    		<i class="feather icon-dollar-sign"></i> 
	    		<span class="menu-title">
	    			Payout
	    		</span>
	    	</router-link>
	    </li> -->
    </ul>
</template>

<script>
	export default {
		data() {
			return {
				activeClass: 'active',
				userRole: ''
			}
		},
		mounted() {
			this.userRole = this.getRole()[0];
		},
		methods: {
			hasPermission(permission){
				return helper.hasPermission(permission);
			},
			hasRole(role){
				return helper.hasRole(role);
			},
			getConfig(config){
				return helper.getConfig(config);
			},
			getRole(role){
              return helper.getRole(role);
            },
			getAuthUser(name){
                return helper.getAuthUser(name);
            },
		},

		computed: {
			currentPage(){
				return this.$route.path;
			},

			currentRouteName() {
				return this.$route.name;
			}
		}
	}
</script>
